
import store from '@/store'
import { getTutorSysMsg, teacheIsIsPaypal, getTutorClassMsgList, getTutorAbsentNotice } from '@/api/layout'
import { NotReadMsgCount } from '@/api/message'
const signalR = require('@aspnet/signalr')
var signalrNotify = {
  // hub链接
  hubConnection: null,
  // hub地址
  hubUrl: 'http://localhost:7008/teacherHub',
  // 重试次数
  tryCount: 10,
  // 已重试次数
  retryCount: 0,
  // 当前用户Id
  currentUserId: 0,
  // 监控计时器
  monitorTime: -1,
  // 方法回调
  functionCallBack: [],
  // 是否显示通知回调日志
  isShowNotifyCallBackLog: false,
  // 是否显示连接日志
  isShowConnectLog: false,
  // 是否localhost
  isLocationDebug: location.hostname === 'localhost',
  // 是否用户关闭 切换tab标签
  closeByCustom: false,
  timer: 60 * 1000,
  isEnableSignalrNotice: false,
  // 初始化
  init: function () {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(this.hubUrl)
      .configureLogging(signalR.LogLevel.Error) //  signalR.LogLevel.Information
      .build()
  },
  isIE: function () {
    var UA = navigator.userAgent
    if (/msie/i.test(UA)) {
      return true
    } else if (UA.toLowerCase().indexOf('trident') && UA.indexOf('rv')) {
      return true
    }
    return false
  },
  // 启动
  start: function () {
    var then = this

    then.isEnableSignalrNotice = store.state.system.isEnableSignalrNotice
    if (!then.isEnableSignalrNotice) {
      then.RegisterAll()// 注册方法
      return
    }

    if (!store.state.user.tuid || store.state.user.tuid <= 0) {
      console.log(`userId(${store.state.user.tuid})不合法`)
      return
    }
    if (store.state.system.signalrNoticeHubUrl && store.state.system.signalrNoticeHubUrl.length > 0) {
      then.hubUrl = store.state.system.signalrNoticeHubUrl
    }

    then.init()
    then.currentUserId = store.state.user.tuid

    // signalrConnect.online(then);//上线
    then.RegisterAll()// 注册方法

    this.connect()

    // tab关闭 刷新 后退事件
    window.addEventListener('beforeunload', function (event) {
      // signalrConnect.offline();//下线
      then.close()// 关闭signalr连接
      // $('body').css({ 'background-color': 'red' });

      if (then.isIE()) {
        return ''
      }
      return null
    })

    // 监听localStorage  同域其他tab设置storage时会触发此监听
    window.addEventListener('storage', function (ev) {
      if (!ev.newValue) {
        return
      }
     if (ev.key.lastIndexOf('-check') > 0) { // 检查存活// == //signalrConnect.checkIsLiveKey+"-check"
        var masterTabId = JSON.parse(ev.newValue).id
        // signalrConnect.checkIsLive(//signalrConnect.checkIsLiveKey.replace("-check", ''), masterTabId);
      } else if (ev.key.lastIndexOf('-signalr') > 0) { // 接收消息
        var data = JSON.parse(ev.newValue)
        // signalrConnect.receiveMsg(ev.key.replace("-signalr", ''), data);
      } else if (ev.key === 'signalrAllClose' && then.hubConnection.connectionState === signalR.HubConnectionState.Connected) {
        signalrNotify.closeByCustom = true
        signalrNotify.close()
      }
    })

    then.hubConnection.onclose(function () {
      then.isShowConnectLog && console.log('disconnected--》连接断开--' + (then.closeByCustom ? '其他上线 通知关闭切换' : '系统断开'))
      then.hubConnection.off('JoinUserNotify')

      if (!then.closeByCustom) {
        setTimeout(function () {
          console.warn('disconnected--》断开--重连')
          then.connect()
        }, 5000) // 5秒重连
      }
    })
  },
  // 连接
  connect: function () {
    var then = this

    if (then.hubConnection.connectionState !== signalR.HubConnectionState.Disconnected) {
      then.isShowConnectLog && console.log('connected--未处于断开状态')
      return
    }

    var connectSignalR = function () {
      then.hubConnection.start().then(function () {
        then.isShowConnectLog & console.log('connected--》连接成功' + then.hubUrl)
        localStorage.setItem('signalrLastConnectTime', (new Date()).getTime())// 最后一次连接时间
        then.joinUser.register()

        then.joinUser.join(then.currentUserId)
      }).catch(function (err) {
        console.warn('connecteFall--》连接失败', err)

        if (then.retryCount >= then.tryCount) {
          console.error('已超过最大重试次数' + then.tryCount + '不再重试')
          return
        }
        setTimeout(function () {
          then.retryCount++
          console.warn('connecteFall--》连接失败--重连')

          then.connect()
        }, 5000)// 5秒重连
      })
    }

    setTimeout(function () { // 等待一秒再连接
      if (then.hubConnection.connectionState !== signalR.HubConnectionState.Disconnected) {
        then.isShowConnectLog && console.log('connected--未处于断开状态')
        return
      }
      connectSignalR()
    }, 1000)
  },
  // 关闭
  close: function () {
    var then = this
    if (then.hubConnection.connectionState === signalR.HubConnectionState.Disconnected) {
      return
    }
    then.hubConnection.stop()
    then.hubConnection.off('JoinUserNotify')
  },
  // 监控连接状态
  monitor: function () {
    var then = this

    if (then.monitorTime) {
      clearInterval(then.monitorTime)
    }

    if (then.retryCount >= then.tryCount) {
      clearInterval(then.monitorTime)
      console.error('已超过最大重试次数' + then.tryCount + '不再监听')
      return
    }

    then.monitorTime = setInterval(function () {
      if (!then.closeByCustom && then.hubConnection.connectionState === signalR.HubConnectionState.Disconnected) { // 判断状态
        if (then.retryCount >= then.tryCount) {
          clearInterval(then.monitorTime)
          console.error('已超过最大重试次数' + then.tryCount + '不再监听')
          return
        }

        then.isReTry = true
        then.connect() // 重试
      }
    }, 60 * 1000)// 每分钟监控
  },
  // 获取方法名
  pushFunctionCallBack: function (func, callBack, eventKey, funcName) {
    var then = signalrNotify

    var isFind = false
    for (var i = 0; i < then.functionCallBack.length; i++) {
      var item = then.functionCallBack[i]
      if (item.funcName === funcName) {
        isFind = true
        break
      }
    }

    if (!isFind) {
      then.functionCallBack.push({ func: func, callBack: callBack, eventKey: eventKey, funcName: funcName })
    }
  },
  RegisterAll: function () {
    var then = this

    // then.getTutorAbsentNoticeNotifyRegister(function(data){
    //   store.dispatch('addAbsentMsg', data)
    // });

    then.getTutorMoodleMsgListNotifyRegister(function(data){
      store.dispatch('addMoodleMsg', data)
    });

    then.getTutorClassMsgListNotifyRegister(function (data) {
      store.dispatch('addClassMsg', data)
    })
    then.getTutorClassRemarkRemindNotifyRegister(function (data) {
       data.remind=true;
      store.dispatch('addSysMsg', data)
    })
    then.getTutorSysMsgListNotifyRegister(function (data) {
      store.dispatch('addSysMsg', data)
    })
    then.teacheIsPaypalModifyNotifyRegister(function (data) {
      store.dispatch('addPaypalMsg', data)
    })
    then.getNotReadMsgCountNotifyRegister(function (data) {
      store.dispatch('addNoReadMsg', data)
    })
    then.endClassNoticeRegister(function (clid) {
      store.dispatch('classDetail/fetchInfo', clid)
    })
    then.getTutorSelfScheduleRemindRegister(function (data) {
      store.dispatch('addSelfScheduleRemindMsg', data)
    })

    then.getTutorDidiMessageRegister(function (data) {
      store.dispatch('addDidiMessage', data)
    })

  },
  // 用户注册
  joinUser: {
    register: function () {
      var then = signalrNotify

      then.hubConnection.on('JoinTeacherNotify', function (data) { // 回调
        then.isLocationDebug && console.log('JoinTeacherNotify', data)

        then.retryCount = 0

        then.monitor()
        then.isShowConnectLog && console.log(data)
      })
    },
    // 注册用户
    join: function (userId) {
      var then = signalrNotify

      if (then.hubConnection.connectionState === signalR.HubConnectionState.Disconnected) {
        then.isShowConnectLog && console.log('connected--处于断开状态，无法jogin')
        return
      }
      then.isLocationDebug && console.log('userId', userId)
      then.hubConnection.invoke('JoinUser', userId).catch(function (error) {
        then.isShowConnectLog && console.log('处于断开状态，无法jogin')
      })// 注册id
    }
  },
  // 重新注册方法
  reRegister: function () {
    var then = this
    for (var i = 0; i < then.functionCallBack.length; i++) {
      var item = then.functionCallBack[i]
      item.func(item.callBack)
    }
  },
  // 执行callback
  execCallBack: function (funcName, data) {
    var index = signalrNotify.functionCallBack.findIndex2(function (a) {
      return a.funcName == funcName
    })
    if (index < 0) {
      return
    }
    var func = signalrNotify.functionCallBack[index]
    if (func && func.callBack) {
      func.callBack(data)
    }
  },
  // http请求
  httpNotice: {

  },
  // 连续缺席实验 
  // getTutorAbsentNoticeNotifyRegister: function (callBack) {
  //   var then = signalrNotify

  //   if (!then.isEnableSignalrNotice) {
  //     getTutorAbsentNotice().then(res => {
  //       console.log(res,'/////');
  //       if (res.data.ErrorCode !== 0) {
  //         setTimeout(() => {
  //           then.getTutorAbsentNoticeNotifyRegister()
  //         }, then.timer)
  //         return
  //       }
  //       if(res.data.Body != null){
  //         callBack(res.data.Body)
  //       console.log('GetTutorAbsentMsg', res)
  //       }
        
  //     })
  //     return
  //   }

  //   then.pushFunctionCallBack(then.getTutorAbsentNoticeNotifyRegister, callBack, 'GetTutorAbsentMsg', 'getTutorAbsentNoticeNotifyRegister')
  //   then.hubConnection.on('GetTutorAbsentMsg', function (data) { // 回调
  //     then.isLocationDebug && console.log('GetTutorAbsentMsg', data)
  //     if (typeof callBack === 'function') {
  //       callBack(data)
  //     }
  //   })
  // },

  getTutorMoodleMsgListNotifyRegister: function (callBack) {
    var then = signalrNotify

    if (!then.isEnableSignalrNotice) {
      getTutorMoodleMsgList().then(res => {
        if (res.data.ErrorCode !== 0) {
          setTimeout(() => {
            then.getTutorMoodleMsgListNotifyRegister()
          }, then.timer)
          return
        }
        callBack(res.data.Body)
        console.log('GetTutorMoodleMsgList', res)
      })
      return
    }

    then.pushFunctionCallBack(then.getTutorMoodleMsgListNotifyRegister, callBack, 'GetTutorMoodleMsgList', 'getTutorMoodleMsgListNotifyRegister')
    then.hubConnection.on('GetTutorMoodleMsgList', function (data) { // 回调
      then.isLocationDebug && console.log('GetTutorMoodleMsgList', data)
      if (typeof callBack === 'function') {
        callBack(data)
      }
    })
  },

  // Notice
  getTutorClassMsgListNotifyRegister: function (callBack) {
    var then = signalrNotify

    if (!then.isEnableSignalrNotice) {
      getTutorClassMsgList().then(res => {
        if (res.data.ErrorCode !== 0) {
          setTimeout(() => {
            then.getTutorClassMsgListNotifyRegister()
          }, then.timer)
          return
        }
        callBack(res.data.Body)
        console.log('getTutorClassMsgList', res)
      })
      return
    }

    then.pushFunctionCallBack(then.getTutorClassMsgListNotifyRegister, callBack, 'GetTutorClassMsgList', 'getTutorClassMsgListNotifyRegister')
    then.hubConnection.on('GetTutorClassMsgList', function (data) { // 回调
      then.isLocationDebug && console.log('GetTutorClassMsgList', data)
      if (typeof callBack === 'function') {
        callBack(data)
      }
    })
  },
  // Notice
  getTutorClassRemarkRemindNotifyRegister: function (callBack) {
    var then = signalrNotify

    if (!then.isEnableSignalrNotice) {
      
      return
    }

    then.pushFunctionCallBack(then.getTutorClassRemarkRemindNotifyRegister, callBack, 'GetTutorClassRemarkRemind', 'getTutorClassRemarkRemindNotifyRegister')
    then.hubConnection.on('GetTutorClassRemarkRemind', function (data) { // 回调
      then.isLocationDebug && console.log('GetTutorClassRemarkRemind', data)
      if (typeof callBack === 'function') {
        callBack(data)
      }
    })
  },
  // 结束课推送
  endClassNoticeRegister: function (callBack) {
    var then = signalrNotify
    if (then.isEnableSignalrNotice) {
      then.pushFunctionCallBack(then.endClassNoticeRegister, callBack, 'getTutorClassMsgList', 'endClassNoticeRegister')
      then.hubConnection.on('AutoEndClassNotice', function (data) { // 回调
        console.log('autoendclass', data)
        if (typeof callBack === 'function') {
          if (location.pathname === `/classDetail/${data}`) {
            // location.reload()
            callBack(data)
          }
        }
      })
    }
  },
  // System Message
  getTutorSysMsgListNotifyRegister: function (callBack) {
    var then = signalrNotify

    if (!then.isEnableSignalrNotice) {
      getTutorSysMsg().then(res => {
        if (res.data.ErrorCode !== 0) {
          setTimeout(() => {
            then.getTutorSysMsgListNotifyRegister()
          }, then.timer)
          return
        }

        callBack(res.data.Body)
        console.log('getTutorSysMsg', res)
      })
      return
    }
    then.pushFunctionCallBack(then.getTutorClassMsgListNotifyRegister, callBack, 'GetTutorSysMsg', 'getTutorSysMsgListNotifyRegister')
    then.hubConnection.on('GetTutorSysMsg', function (data) { // 回调
      console.log('GetTutorSysMsg', data)
      if (typeof callBack === 'function') {
        callBack(data)
      }
    })
  },
  // 工资账户修改通知
  teacheIsPaypalModifyNotifyRegister: function (callBack) {
    var then = signalrNotify

    if (!then.isEnableSignalrNotice) {
      // teacheIsIsPaypal().then(res => {
      //   if (res.data.ErrorCode !== 0) {
      //     setTimeout(() => {
      //       then.teacheIsPaypalModifyNotifyRegister()
      //     }, then.timer)
      //     return
      //   }

      //   callBack({ salaryAccount: res.data.Body.account })
      //   console.log('teacheIsIsPaypal', res)
      // })
      return
    }

    then.pushFunctionCallBack(then.getTutorClassMsgListNotifyRegister, callBack, 'TeacheIsPaypalModify', 'teacheIsPaypalModifyNotifyRegister')
    then.hubConnection.on('TeacheIsPaypalModify', function (data) { // 回调
      then.isLocationDebug && console.log('TeacheIsPaypalModify', data)
      if (typeof callBack === 'function') {
        callBack(data)
      }
    })
  },
  // 未读消息
  getNotReadMsgCountNotifyRegister: function (callBack) {
    var then = signalrNotify

    if (!then.isEnableSignalrNotice) {
      NotReadMsgCount().then(res => {
        if (res.data.ErrorCode !== 0) {
          setTimeout(() => {
            then.getNotReadMsgCountNotifyRegister()
          }, then.timer)
          return
        }

        callBack(res.data.Body)
        console.log('NotReadMsgCount', res)
      })
      return
    }

    then.pushFunctionCallBack(then.getNotReadMsgCountNotifyRegister, callBack, 'GetTutorNotReadMsgCount', 'getNotReadMsgCountNotifyRegister')
    then.hubConnection.on('GetTutorNotReadMsgCount', function (data) { // 回调
      then.isLocationDebug && console.log('GetTutorNotReadMsgCount', data)
      if (typeof callBack === 'function') {
        callBack(data)
      }
    })
  },
  // 自主放课提示
  getTutorSelfScheduleRemindRegister: function (callBack) {
    var then = signalrNotify

    if (!then.isEnableSignalrNotice) {
      console.log("hubConnection 未注册！！")
      return
    }

    then.pushFunctionCallBack(then.getTutorSelfScheduleRemindRegister, callBack, 'GetTutorSelfScheduleRemind', 'getTutorSelfScheduleRemindRegister')
    then.hubConnection.on('GetTutorSelfScheduleRemind', function (data) { // 回调
      then.isLocationDebug && console.log('GetTutorSelfScheduleRemind', data)
      if (typeof callBack === 'function') {
        callBack(data)
      }
    })
  },

  // didi打老师
  getTutorDidiMessageRegister: function (callBack) {
    var then = signalrNotify

    if (!then.isEnableSignalrNotice) {
      console.log("hubConnection 未注册！！")
      return
    }

    then.pushFunctionCallBack(then.getTutorDidiMessageRegister, callBack, 'GetTeacheDidiMessage', 'getTutorDidiMessageRegister')
    then.hubConnection.on('GetTeacheDidiMessage', function (data) { // 回调
      then.isLocationDebug && console.log('GetTeacheDidiMessage', data)
      if (typeof callBack === 'function') {
        callBack(data)
      }
    })
  }
}

Date.prototype.pattern = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours() % 12 == 0 ? 12 : this.getHours() % 12, // 小时
    'H+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds() // 毫秒
  }
  var week = {
    '0': '\u65e5',
    '1': '\u4e00',
    '2': '\u4e8c',
    '3': '\u4e09',
    '4': '\u56db',
    '5': '\u4e94',
    '6': '\u516d'
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '\u661f\u671f' : '\u5468') : '') + week[this.getDay() + ''])
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

export default signalrNotify
